import {APP_LOCAL_DATE_FORMAT} from "@mytour/shared";
import type {Dayjs} from "dayjs";

export type RelaunchCount = 0 | 1 | 2;

/**
 * « Rappel programmé le A. » / « Rappels programmés le A puis le B. » / «
 * Rappels programmés le A, le B puis le C. » — phrase exacte du PRD pour 0/1
 * relance, étendue par le même patron pour 2.
 */
export function buildRelaunchPhrase(dates: Dayjs[]): string {
  const formatted = dates.map((date) => date.format(APP_LOCAL_DATE_FORMAT));
  if (formatted.length === 1) {
    return `Rappel programmé le ${formatted[0]} tant que le client n'a pas repris rendez-vous.`;
  }
  const last = formatted.at(-1);
  const leading = formatted
    .slice(0, -1)
    .map((date) => `le ${date}`)
    .join(", ");
  return `Rappels programmés ${leading} puis le ${last} tant que le client n'a pas repris rendez-vous.`;
}
